import './lib/patch-dom-for-extensions';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app';
import './languages/dayjs';
import './languages/i18n';
import { installChunkLoadRecovery } from './lib/chunk-load-recovery';

installChunkLoadRecovery();

const rootElement = document.getElementById('app')!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
